
export default {
    mainWidth:1920,
    mainHeight:1038,
}
